import React from 'react'
import { useTranslation } from '@/localization/useTranslation'
import { TranslationType } from '@/types'

import classes from './style.module.scss'

interface FormHeaderProps {
  /** A translation object from the cinematic, or a translation key. */
  title?: TranslationType | string
  /** Optional supporting line under the title. */
  subtitle?: TranslationType | string
  /** Form-owned note (e.g. "*Required fields"), rendered last. */
  message?: React.ReactNode
  titleTestId?: string
  messageTestId?: string
}

/**
 * The title/subtitle block every auth form shows. Kept in one place so a new
 * slot (this subtitle, for instance) lands in every form at once instead of
 * being copy-pasted into each one.
 */
export const FormHeader: React.FC<FormHeaderProps> = (props) => {
  const { title, subtitle, message, titleTestId, messageTestId } = props
  const { t } = useTranslation()

  const resolvedTitle = title ? t(title) : ''
  const resolvedSubtitle = subtitle ? t(subtitle) : ''

  if (!resolvedTitle && !resolvedSubtitle && !message) return null

  return (
    <header className={classes.header}>
      {resolvedTitle && (
        <h2 className={classes.title} data-testid={titleTestId}>{resolvedTitle}</h2>
      )}
      {resolvedSubtitle && (
        <p className={classes.subtitle}>{resolvedSubtitle}</p>
      )}
      {message && (
        <h3 className={classes.message} data-testid={messageTestId}>{message}</h3>
      )}
    </header>
  )
}
